import { css } from 'lit';

export default css`
  :host {
    display: flex;
    vertical-align: middle;
  }

  sl-listbox {
    background: var(--sl-elevation-surface-raised-default);
    border: var(--sl-size-borderWidth-default) solid var(--sl-color-border-plain);
    border-radius: var(--sl-size-borderRadius-default);
    box-shadow: var(--sl-elevation-shadow-overlay);
    box-sizing: border-box;
    display: none;
    margin: 0;
    opacity: 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    sl-listbox {
      transition: 0.2s cubic-bezier(0.25, 0, 0.3, 1);
      transition-behavior: allow-discrete;
      transition-property: display, opacity;
    }
  }

  sl-listbox:popover-open {
    display: flex;
    opacity: 1;
  }
`;
